import React from 'react'
import {qs} from '../util'
import {useLocation} from '@reach/router'

export const withQueryParams = (Component) => {
  return (props) => {
    const location = useLocation()
    let query = {}
    if (location.search) {
      query = qs(location.search)
    }
    return <Component {...{...props, query}}/>
  }
}